"use client";

import React, { createContext, useCallback, useContext, useState } from "react";

type ProductCardHighlightContextValue = {
  highlightedCardId: string | null;
  setHighlightedCardId: (cardId: string) => void;
};

const ProductCardHighlightContext = createContext<ProductCardHighlightContextValue | undefined>(undefined);

export const ProductCardHighlightProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [highlightedCardId, setHighlightedCardIdState] = useState<string | null>(null);

  const setHighlightedCardId = useCallback((cardId: string) => {
    setHighlightedCardIdState(cardId);
  }, []);

  return (
    <ProductCardHighlightContext.Provider value={{ highlightedCardId, setHighlightedCardId }}>
      {children}
    </ProductCardHighlightContext.Provider>
  );
};

export const useProductCardHighlight = () => {
  const context = useContext(ProductCardHighlightContext);
  if (!context) {
    throw new Error("useProductCardHighlight must be used within a ProductCardHighlightProvider");
  }
  return context;
};
